import { render, staticRenderFns } from "./ModattaStepInteraction.vue?vue&type=template&id=22fb7708&scoped=true"
import script from "./ModattaStepInteraction.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteraction.vue?vue&type=script&lang=js"
import style0 from "./ModattaStepInteraction.vue?vue&type=style&index=0&id=22fb7708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb7708",
  null
  
)

export default component.exports